export class RandomManager {
  private state: number;
  readonly seed: number;

  constructor(seed = RandomManager.createSeed()) {
    this.seed = seed >>> 0 || 1;
    this.state = this.seed;
  }

  static createSeed(): number {
    const time = Date.now() >>> 0;
    const cryptoValue = globalThis.crypto?.getRandomValues?.(new Uint32Array(1))[0] ?? 0x9e3779b9;
    return (time ^ cryptoValue) >>> 0;
  }

  next(): number {
    let x = this.state;
    x ^= x << 13;
    x ^= x >>> 17;
    x ^= x << 5;
    this.state = x >>> 0;
    return this.state / 4294967296;
  }

  range(min: number, max: number): number {
    return min + (max - min) * this.next();
  }

  int(min: number, max: number): number {
    return Math.floor(this.range(min, max + 1));
  }

  pick<T>(items: readonly T[]): T {
    return items[this.int(0, items.length - 1)];
  }

  chance(probability: number): boolean {
    return this.next() < Math.max(0, Math.min(1, probability));
  }
}
